/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetMissingTranslationsRequest
 */
export interface GetMissingTranslationsRequest {
    /**
     * 
     * @type {string}
     * @memberof GetMissingTranslationsRequest
     */
    object_type: string;
    /**
     * 
     * @type {string}
     * @memberof GetMissingTranslationsRequest
     */
    id: string;
}

/**
 * Check if a given object implements the GetMissingTranslationsRequest interface.
 */
export function instanceOfGetMissingTranslationsRequest(value: object): value is GetMissingTranslationsRequest {
    if (!('object_type' in value) || value['object_type'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetMissingTranslationsRequestFromJSON(json: any): GetMissingTranslationsRequest {
    return GetMissingTranslationsRequestFromJSONTyped(json, false);
}

export function GetMissingTranslationsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMissingTranslationsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'object_type': json['object_type'],
        'id': json['id'],
    };
}

export function GetMissingTranslationsRequestToJSON(json: any): GetMissingTranslationsRequest {
    return GetMissingTranslationsRequestToJSONTyped(json, false);
}

export function GetMissingTranslationsRequestToJSONTyped(value?: GetMissingTranslationsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'object_type': value['object_type'],
        'id': value['id'],
    };
}

